import { render, staticRenderFns } from "./QuoteCustomer.vue?vue&type=template&id=6f342f68&scoped=true"
import script from "./QuoteCustomer.vue?vue&type=script&lang=js"
export * from "./QuoteCustomer.vue?vue&type=script&lang=js"
import style0 from "./QuoteCustomer.vue?vue&type=style&index=0&id=6f342f68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f342f68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f342f68')) {
      api.createRecord('6f342f68', component.options)
    } else {
      api.reload('6f342f68', component.options)
    }
    module.hot.accept("./QuoteCustomer.vue?vue&type=template&id=6f342f68&scoped=true", function () {
      api.rerender('6f342f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteHeader/QuoteCustomer.vue"
export default component.exports